import { render } from "./ReturnPortal.vue?vue&type=template&id=5520656f"
import script from "./ReturnPortal.vue?vue&type=script&lang=js"
export * from "./ReturnPortal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__